import React, { useMemo } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { logger } from '@fiverr-private/obs';
import { useCurrentTabSellerRole } from '../RolePageTabContentRoleProvider';
import { useOrderedSkills } from '../../hooks/useOrderedSkills';
import { mapSkills } from '../../utils/mapSkills';
import { SkillsContent } from './SkillsContent';
import { SkillsTitle } from './SkillsTitle';

export const RolePageSkills = () => (
    <ErrorBoundary onError={onRenderError}>
        <RolePageSkillsInner />
    </ErrorBoundary>
);

const RolePageSkillsInner = () => {
    const sellerRole = useCurrentTabSellerRole();
    const skills = useMemo(() => (sellerRole?.proficient ? mapSkills(sellerRole.proficient) : []), [sellerRole]);
    const orderedSkills = useOrderedSkills(skills, sellerRole?.id);

    if (!sellerRole?.proficient.length) {
        return null;
    }

    return (
        <>
            <Stack direction="column" gap="4">
                <SkillsTitle />
                <SkillsContent skills={orderedSkills} />
            </Stack>
        </>
    );
};

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the "RolePageSkills" Component');
    logger.error(err, { cause: originalError });
};
